export { default } from "./src/body-content";
export type { UniformBodyContentProps } from "./src/body-content";
